'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './housing.routes';

export class HousingComponent {
  /*@ngInject*/
  constructor($state, $scope, $rootScope, fetch, lookup, userService, $stateParams) {
    const vm = this;
    this.$scope = $scope;
    this.$state = $state;
    this.fetch = fetch;
    this.lookup = lookup;
    this.$stateParams = $stateParams;
    this.userService = userService;

    $scope.currentlySelectedPolicies = [];
    $scope.productionCount = 0;
    $scope.preservationCount = 0;
    $scope.protectionCount = 0;
    $scope.commercialCount = 0;
    $scope.activityType = 'Housing';
    

    $scope.getProductionSubmissionStatus = function(){
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Housing Production Policy')
      .then(response => {
        $scope.housingProductionStatus = _.filter(response.data, 'housing_policy_name');
       if(response.data.length > 0){
        $scope.productionCount = (_.uniq(_.map($scope.housingProductionStatus, 'housing_policy_name'))).length;
       } else {
        $scope.productionCount = 0;
       }
       $scope.loadingSummaries = false;
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.getProtectionSubmissionStatus = function(){
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Housing Protection Policy')
      .then(response => {
        $scope.housingProtectionStatus = response.data;
        $scope.housingProtectionStatus = _.filter(response.data, 'housing_policy_name');
        if(response.data.length > 0){
          $scope.protectionCount = (_.uniq(_.map($scope.housingProtectionStatus, 'housing_policy_name'))).length;
        } else {
          $scope.protectionCount = 0;
        }
        $scope.loadingSummaries = false;
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.getPreservationSubmissionStatus = function(){
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Housing Preservation Policy')
      .then(response => {
        $scope.housingPreservationStatus = response.data;
        $scope.housingPreservationStatus = _.filter(response.data, 'housing_policy_name');
        if(response.data.length > 0){
          $scope.preservationCount = (_.uniq(_.map($scope.housingPreservationStatus, 'housing_policy_name'))).length;
        } else {
          $scope.preservationCount = 0;
        }
        $scope.loadingSummaries = false;
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.getCommercialSubmissionStatus = function(){
      fetch.getItem(`api/data/submissions/${$scope.currentJurisdiction}/${$scope.currentSelectedStationId}`, 'Housing Commercial Policy')
      .then(response => {
        $scope.housingCommercialStatus = response.data;
        $scope.housingCommercialStatus = _.filter(response.data, 'housing_policy_name');
       if(response.data.length > 0){
        $scope.commercialCount = (_.uniq(_.map($scope.housingcCommercialStatus, 'housing_policy_name'))).length;
       } else {
        $scope.commercialCount = 0;
       }
       $scope.loadingSummaries = false;
      })
      .catch(err => {
        console.log(err);
        if(err.status === 403){
          $state.go('login');
        }
      })
    }

    $scope.getStationbyID = function(station){
      $scope.loadingSummaries = true;
      if(station){
        $scope.currentSelectedStationId = station;
        lookup.setCurrentStation(station);
        $scope.getProductionSubmissionStatus();
        $scope.getCommercialSubmissionStatus();
        $scope.getProtectionSubmissionStatus();
        $scope.getPreservationSubmissionStatus();
        $scope.getActivity();

          vm.getStationAreaSubmissionSummary($scope.currentSelectedStationId);
          
      }
      
    }
 
    /**
* Update station area dropdown based on jurisdiction selected
* @param {*} jurisdiction 
*/
    $scope.getStationAreaList = function (jurisdiction) {
      lookup.setJurisdiction(jurisdiction);
      fetch.getAllItems(`api/data/stationareas/${jurisdiction}`)
        .then(response => {
          
          $scope.stationAreas = response.data;
          if (lookup.getCurrentStation()) {
            $scope.currentSelectedStationId = lookup.getCurrentStation();
            $scope.getStationbyID($scope.currentSelectedStationId)
          }
        })
        .catch(err => {
          console.log(err);
          if(err.status === 403){
            $state.go('login');
          }
        })
    }

        /**
    * @function getsubmissionActivity
    * @description Gets the density activity data
    */
        $scope.getActivity = function(){
          var activityData = [];
          fetch.getAllItems(`api/data/submission/activity/${$scope.currentSelectedStationId}/${$scope.activityType}`)
          .then(response => {
            
            $scope.submissionActivity = response.data;
           })
          .catch(err => {
            console.log(err);
            if(err.status === 403){
              $state.go('login');
            }
          })
        }
  }

  $onInit(){
    this.$scope.submissionActivity = [];
    
    this.userService.getCurrentUser()
    .then(response => {
      
      this.$scope.currentUser = response.data;
      this.userService.setCurrentUser(response.data);
      this.getJurisdictionList();
      this.$scope.housingProductionForms = [];
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
  }

  getJurisdictionList() {
    this.fetch.getAllItems('api/data/jurisdictions/jurisdiction-list')
    .then(response => {
        this.$scope.loading = false;
        this.$scope.jurisdictions = response.data;

    // Check if user role is Administrator
    if (this.$scope.currentUser.role === 'Administrator') {
      console.log("admin");
      // Check for the jurisdiction parameter in the URL
      const jurisdictionParam = this.$stateParams.jurisdiction;
      console.log(this.$stateParams);
      if (jurisdictionParam) {
        this.$scope.currentJurisdiction = jurisdictionParam;
      } else if (this.lookup.getJurisdiction()) {
        this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
      } else {
        // If no parameter, default to the first jurisdiction
        this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
      }
    } else {
       if (this.lookup.getJurisdiction()) {
        this.$scope.currentJurisdiction = this.lookup.getJurisdiction();
      } else {
        // If no parameter, default to the first jurisdiction
        this.$scope.currentJurisdiction = this.$scope.jurisdictions[0].jurisdiction;
      }
    }

        console.log(this.$scope.currentJurisdiction);
        this.lookup.setJurisdiction(this.$scope.currentJurisdiction);
        this.$scope.getStationAreaList(this.$scope.currentJurisdiction);
    })
    .catch(err => {
        console.log(err);
    });
}

  getHousingPreservationForms(){
    this.fetch.getAllItems('api/data/housing/forms/Alameda/Preservation')
    .then(response => {
      
      response.data.forEach(element => {
        if(element.policy_selected){
          this.$scope.currentlySelectedPolicies.push(element);
        }
      });
      this.$scope.housingPreservationForms = response.data;
      this.getSelectedCount();
    })
  }

  getHousingProtectionForms(){
    this.fetch.getAllItems('api/data/housing/forms/Alameda/Protection')
    .then(response => {
      response.data.forEach(element => {
        if(element.policy_selected){
          this.$scope.currentlySelectedPolicies.push(element);
        }
      });
      this.$scope.housingProtectionForms = response.data;
      this.getSelectedCount();
    })
  }

  getHousingProductionForms(){
    this.fetch.getAllItems('api/data/housing/forms/Alameda/Production')
    .then(response => {
      
      response.data.forEach(element => {
        if(element.policy_selected){
          this.$scope.currentlySelectedPolicies.push(element);
        }
      });
      this.$scope.housingProductionForms = response.data;
      this.getSelectedCount();
    })
  }

  getHousingCommercialForms(){
    this.fetch.getAllItems('api/data/housing/forms/Alameda/Commercial')
    .then(response => {
      
      this.$scope.housingCommercialForms = response.data;
      this.getSelectedCount();
    })
  }

  updateSelected(item){
    if(item.policy_selected){
      this.$scope.currentlySelectedPolicies.push(item);
    } else {
      for( var i = 0; i < this.$scope.currentlySelectedPolicies.length; i++){ 
        if ( this.$scope.currentlySelectedPolicies[i].housing_form_id === item.housing_form_id) { 
          this.$scope.currentlySelectedPolicies.splice(i, 1); 
        }
    }
    }
    var upsertData = {
      policy_selected: item.policy_selected,
      housing_form_id: item.housing_form_id
    }
    this.fetch.updateItem('api/data/housing/forms/update', upsertData)
    .then(response => {
      var selectedCheck = _.filter(this.$scope.currentlySelectedPolicies, {'housing_form_id': item.housing_form_id});
      this.getSelectedCount();
    })
    .catch(err => {
      console.log(err);
      if(err.status === 403){
        this.$state.go('login');
      }
    })
  }

  getSelectedCount(){
    this.$scope.productionSelected = _.filter(this.$scope.housingProductionForms,{policy_selected: true});
    this.$scope.protectionSelected = _.filter(this.$scope.housingProtectionForms,{policy_selected: true});
    this.$scope.preservationSelected = _.filter(this.$scope.housingPreservationForms,{policy_selected: true});
    this.$scope.commercialSelected = _.filter(this.$scope.housingCommercialForms,{policy_selected: true});
  }

  getStationAreaSubmissionSummary(stationId) {
    console.log('Getting summary for station:', stationId);
    this.lookup.setCurrentStation(stationId);

    if (this.$scope.stationAreas.length > 0) {
      this.$scope.stationAreas.forEach(element => {
        element.active = element.sta_recid === stationId;
        if (element.active) {
          this.$scope.stationAreaTitle = element.station_name;
        }
      });

      return this.fetch.getItem(
        `api/data/policies/${this.$scope.currentJurisdiction}`,
        stationId
      )
        .then(response => {
          console.log('Policy data:', response);
           this.$scope.submissionSummary = response.data;
          console.log("submission summary: ", this.$scope.submissionSummary);
          this.lookup.setSubmissionPolicies(this.$scope.submissionSummary);

          // Process density submissions
          this.$scope.densitySubmissions = _.filter(response.data,
            { submission_policy_type: "Density" });
          this.$scope.densitySubmitted = _.filter(this.$scope.densitySubmissions,
            { submitted: true });
          this.$scope.densityCompliant = _.filter(this.$scope.densitySubmissions,
            { status: 'Compliant' });

          // Process housing policy submissions
          this.$scope.housingPolicySubmissions = _.filter(response.data,
            { submission_policy_type: "Housing Production Policy" });
          this.$scope.housingPolicySubmissions = _.union(
            this.$scope.housingPolicySubmissions,
            _.filter(response.data, { submission_policy_type: "Housing Preservation Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Protection Policy" }),
            _.filter(response.data, { submission_policy_type: "Housing Commercial Policy" })
          );
          this.$scope.housingPolicySubmitted = _.filter(
            this.$scope.housingPolicySubmissions,
            { submitted: true }
          );
          this.$scope.housingPolicyCompliant = _.filter(
            this.$scope.housingPolicySubmissions,
            { status: 'Compliant' }
          );

          // Process parking submissions
          this.$scope.parkingSubmissions = _.filter(response.data,
            { submission_policy_type: "Parking" });
          this.$scope.parkingSubmitted = _.filter(this.$scope.parkingSubmissions,
            { submitted: true });
          this.$scope.parkingCompliant = _.filter(this.$scope.parkingSubmissions,
            { status: 'Compliant' });

          // Process station access submissions
          this.$scope.stationAccessSubmissions = _.filter(response.data,
            { submission_policy_type: "Station Area Access" });
          this.$scope.stationAccessSubmitted = _.filter(
            this.$scope.stationAccessSubmissions,
            { submitted: true }
          );
          this.$scope.stationAccessCompliant = _.filter(
            this.$scope.stationAccessSubmissions,
            { status: 'Compliant' }
          );
        });

      this.$scope.loading = false;
    } else {
      this.$scope.stationAreaTitle = '--';
      return Promise.resolve();
    }
  }

}

export default angular.module('appApp.housing', [uiRouter])
  .config(routes)
  .component('housing', {
    template: require('./housing.html'),
    controller: HousingComponent,
    controllerAs: 'housingCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/housing/housing.component.js